module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutFreeGift":{"progress":{"text":"Nakupte ještě za {price} {textBold}","textBold":"a dostanete dárek zdarma"},"active":"Dárek zdarma!"}}}')
  delete Component.options._Ctor
}
